import * as _4 from 'lodash4';
import {
  IMultiChoiceQuestionModel,
  IMultiValidationCallbackParams,
  IMutatedChoice
} from '../../types/poll_question_types';
import { INgPolymerEvent, IQuestionBuilderDTD } from './../../poll_interfaces';

export class MultiplePollComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-poll/src/components/multiple_poll/multiple_poll.html';
  public controller: any = 'MultiplePollController';
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    question: '<',
    validationCallback: '<?',
    labelledBy: '@'
  };
}

export class MultiplePollController {
  private models: IMultiChoiceQuestionModel;
  private validationCallback: (params: IMultiValidationCallbackParams) => void;
  private question: IQuestionBuilderDTD;

  constructor() {
    this.models = {
      choices: []
    };
  }

  $onInit(): void {
    this.validationCallback = _4.isFunction(this.validationCallback) ? this.validationCallback : angular.noop;
    this.validate();
  }

  $onChanges(changeObj: any) {
    if (!_4.isEmpty(changeObj)) {
      _4.map(
        changeObj.question.currentValue._active_choices,
        (choice: IMutatedChoice) => (choice.isSelected = !!choice.answered)
      );
      this.validate();
    }
  }

  setChoice(evt: INgPolymerEvent, choice: IMutatedChoice) {
    choice.isSelected = evt.originalEvent.target.checked;
    this.validate();
  }

  _getChoicesNk(): any {
    return _4.isEmpty(this.question)
      ? undefined
      : _4.filter(this.question._active_choices, (choice: IMutatedChoice) => choice.isSelected);
  }

  validate(): void {
    this.models.choices = this._getChoicesNk();
    this.validationCallback({
      isValid: !_4.isEmpty(this.models.choices),
      selectedResponse: this.models.choices
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/components/multiple_poll/multiple_poll.ts